import { render, staticRenderFns } from "./checkbox.component.vue?vue&type=template&id=2c7326d8&scoped=true&"
import script from "./checkbox.component.vue?vue&type=script&lang=ts&"
export * from "./checkbox.component.vue?vue&type=script&lang=ts&"
import style0 from "./checkbox.component.vue?vue&type=style&index=0&id=2c7326d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7326d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VRow})
